module.exports = __webpack_public_path__ + "static/media/edit_button.7ca4c68f.png";


//////////////////
// WEBPACK FOOTER
// ./src/edit_button.png
// module id = 394
// module chunks = 0